import { Grid } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";
import { CardItem, Loader, NoData } from ".";

const DocumentGrid = ({ loading = false, documents = [], onDocumentClick, isEditable, onEdit }) => {
  const intl = useIntl();
  return (
    <Loader loading={loading}>
      <NoData
        message={intl.formatMessage({
          id: "Shared.DocumentGrid.NoDocumentData",
          defaultMessage: "There are no documents. Please check later for new contents..."
        })}
        data={documents}
      >
        <Grid container spacing={3}>
          {documents.map(({ id, pdf, title, description }) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={id}>
              <CardItem
                title={title}
                description={description}
                thumbUrl={pdf?.previewUrl || ""}
                onClick={
                  onDocumentClick && (() => onDocumentClick({ id, pdf, title, description }))
                }
                isEditable={isEditable}
                onEdit={e => {
                  onEdit({ id });
                  e.stopPropagation();
                }}
              />
            </Grid>
          ))}
        </Grid>
      </NoData>
    </Loader>
  );
};

export default DocumentGrid;
